import { useEffect, useState } from "react";
import API from "../../lib/api";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const NONE = "__none__";

/** Optional asset link for a job — narrows to the chosen property/client when one is set. */
export function AssetPicker({ value, propertyId, clientId, onChange, testid = "job-asset-picker" }) {
  const [assets, setAssets] = useState([]);
  useEffect(() => { API.get("/assets", { params: { status: "active" } }).then((r) => setAssets(r.data)).catch(() => setAssets([])); }, []);
  const scoped = assets.filter((a) => (!propertyId || a.property_id === propertyId) && (!clientId || !a.client_id || a.client_id === clientId));
  const list = scoped.length ? scoped : assets;
  if (!assets.length) return null;
  return (
    <div className="col-span-2">
      <Label>Asset (optional)</Label>
      <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : list.find((a) => a.id === v) || assets.find((a) => a.id === v))}>
        <SelectTrigger className="mt-1" data-testid={testid}><SelectValue placeholder="Link to a registered asset" /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>No asset</SelectItem>
          {list.map((a) => <SelectItem key={a.id} value={a.id}>{a.name}{a.tag_code ? ` · ${a.tag_code}` : ""}{a.property_name ? ` — ${a.property_name}` : ""}</SelectItem>)}
        </SelectContent>
      </Select>
      <p className="text-[10px] text-muted-foreground mt-1">Completing the job writes a service/repair entry into the asset's history.</p>
    </div>
  );
}
